export const getParamValue = (search: string, param: string) => {
  if (!search) {
    return undefined;
  }
  const urlParams = new URLSearchParams(search);
  return urlParams.get(param);
};
